import MoveItemToCollectionModal from './MoveItemToCollectionModal.container'
export default MoveItemToCollectionModal
